import type { ReactNode } from 'react';

interface HeaderCardProps {
  left: ReactNode;
  right: ReactNode;
}

export function HeaderCard({ left, right }: HeaderCardProps): JSX.Element {
  return (
    <div className="flex items-center justify-between card px-3 py-2">
      <div className="flex items-center gap-4 min-w-0">{left}</div>
      <div className="flex items-center gap-4 flex-wrap justify-end">{right}</div>
    </div>
  );
}
